<template>
  <div>
    <label class="block text-sm font-semibold leading-6 text-gray-900 mb-2">
      <slot name="label" />
    </label>
    <div class="relative rounded-md shadow-sm">
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
      >
        <slot name="icon-right" />
      </div>
      <vue-tel-input
        v-model="data"
        :disabled="disabled"
        style-classes="!rounded-md !border-0 !px-1.5 !py-[0.45rem] md:!py-[0.39rem] !text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus-within:!ring-2 focus-within:!ring-inset focus-within:!ring-blue-600"
        :input-options="{ showDialCode: true }"
        :required="true"
        :valid-characters-only="true"
        @validate="handleValidation"
        @input="$emit('input', $event)"
      ></vue-tel-input>
    </div>
    <div v-if="hasErrors" class="text-red-500">
      <div v-for="error of errors" :key="error.$uid" class="input-errors">
        <div class="error-msg">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-1.5 text-slate-500">
      <slot name="assistance" />
    </div>
  </div>
</template>
<script lang="ts">
// use normal <script> to declare options
export default {
  inheritAttrs: false,
}
</script>
<script lang="ts" setup>
const props = defineProps<{
  modelValue?: string | number
  errors?: any[]
  type?: string
  required?: boolean
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue', 'validate'])
const data = useVModel(props, 'modelValue', emit)

const handleValidation = (phoneObject) => {
  emit('validate', phoneObject.valid || false)
}

const hasErrors = computed(() => Boolean(props.errors?.length > 0))
</script>
<style scoped>
:deep(.vti__dropdown-item strong) {
  font-weight: 400 !important;
}
</style>
